import * as angular from 'angular';

import { ChartConfigurationOption } from '../../framework';
import { ScatterWidget } from '../../widgets/scatter/scatter.widget';
import { WidgetValues, ComponentDefinition } from '../../models';
import { DataPoint, IScatterPlotService, IExportToCsvService } from '../../services';
import { ShapeFormat } from '../../wtFramework';

class BoundScatterPlotController implements angular.IComponentController {
    data: DataPoint[];
    options: ChartConfigurationOption;
    series: any[];
    shapes: ShapeFormat[];

    readonly boundData: WidgetValues;
    readonly boundSeries: any[];
    readonly disableCrosshair: boolean;
    readonly item: ScatterWidget;
    readonly ratio: number;

    private _xSeries: any;

    static $inject = ['ScatterPlotService', 'exportToCsvService'];

    constructor(
        private _scatterPlotService: IScatterPlotService,
        private _exportToCsvService: IExportToCsvService
    ) {
    }

    $onInit() {
        if (this.item) {
            this.item.exportToCsv = () => {
                return this._exportToCsvService.exportToCsv(this.series, this.boundData.values.concat(this.boundData.aggregatedValues), this.item.name);
            };
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['item'] && changesObj['item'].currentValue) {
            const configuration = changesObj['item'].currentValue.configuration;
            this.options = configuration.options;
            this.shapes = this._scatterPlotService.mapShapes(configuration.shapes, this.boundData ? this.boundData.aggregatedValue : null, this.item.map);
        }
        if (changesObj['boundSeries'] && changesObj['boundSeries'].currentValue) {
            if (this.boundSeries && this.boundSeries.length > 0) {
                this.mapSeries(this.boundSeries);
            }
        }
        if (changesObj['boundData'] && changesObj['boundData'].currentValue) {
            if (this.boundData.values && this.series && this._xSeries) {
                this.data = this._scatterPlotService.arrangeData(this.boundData.values.concat(this.boundData.aggregatedValues), this._xSeries, this.series);
            }
            const configuration = this.item.configuration;
            if (configuration) {
                this.shapes = this._scatterPlotService.mapShapes(configuration.shapes, this.boundData ? this.boundData.aggregatedValue : null, this.item.map);
            }
        }
    }

    private mapSeries(series: any[]) {
        //const itemSeriesConfiguration = this.item.getSeries();
        // #31540: Commented to include xSeries for crosshair.
        const filtered = series;
        this.series = filtered;
        // #40782 : set proper y axis title
        const ySeries = this.series.filter(s => !s.isXAxis);
        if (ySeries.length) {
            this.options.yAxis.title = ySeries[0].name;
        }
        const xAxis = series.filter(s => !!s.isXAxis);
        if (xAxis.length) {
            const xSeries = xAxis[0];
            this._xSeries = xSeries;
            this.options.xAxis.guid = xSeries.guid;
            this.options.xAxis.title = xSeries.name;
        }
        if (this.boundData && this.boundData.values) {
            this.data = this._scatterPlotService.arrangeData(this.boundData.values, this._xSeries, this.series);
        }
    }
}

export const wtBoundScatterPlot: ComponentDefinition = {
    componentId: 'wtBoundScatterPlot',
    controller: BoundScatterPlotController,
    template: require('./boundScatterPlot.component.html'),
    controllerAs: 'vm',
    bindings: {
        boundData: '<',
        boundSeries: '<',
        disableCrosshair: '<?',
        item: '<',
        ratio: '<?'
    }
};